module.exports = __webpack_public_path__ + "static/shopee-20062e798fd5a759e282ad96665979ed.png";